import styled from '@emotion/styled'

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #515157;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  z-index: 1;
`

export const Text = styled.div`
  color: #fff;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
`

export const Buttons = styled.div`
  display: flex;
  gap: 12px;
`

export const OverlayButton = styled.button`
  display: flex;
  height: 22px;
  padding: 0 8px;
  align-items: center;
  gap: 4px;
  border-radius: 3px;
  border: 1px solid #0b2e6b;
  background: #fff;
  cursor: pointer;
  font-family: Arial;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #0b2e6b;
  box-sizing: border-box;
  &:hover {
    border-color: #1e7aff;
    color: #1e7aff;
  }
`
